// src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { JOURNEY_TOKEN_STORAGE_KEY } from "../services/reservationService";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [validated, setValidated] = useState(false);
  const [allowed, setAllowed] = useState(true);

  useEffect(() => {
    const guestAccessToken = localStorage.getItem(JOURNEY_TOKEN_STORAGE_KEY);
    const reservationCode = localStorage.getItem("reservation-code");
    const departureStr = localStorage.getItem("departure");

    if (!guestAccessToken || !reservationCode || !departureStr) {
      setAllowed(false);
      setValidated(true);
      return;
    }

    const departureDate = new Date(departureStr);
    const now = new Date();

    setAllowed(Boolean(departureDate && departureDate > now));
    setValidated(true);
  }, [location.pathname]);

  if (!validated) return <div className="loading">Validating access...</div>;

  return allowed ? children : <Navigate to="/access-denied" replace />;
};

export default ProtectedRoute;
